module.exports = __webpack_public_path__ + "static/media/uruguay-mundial.8b19157c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/uruguay-mundial.png
// module id = 492
// module chunks = 0 1 2